import cn from 'classnames';
import * as React from 'react';

import classes from './DialogContent.module.scss';
import { DialogContentProps } from './DialogContent.types';

export const DialogContent = ({ classes: receivedClasses = {}, children }: DialogContentProps) => (
    <div className={cn(classes.root, receivedClasses?.root)}>{children}</div>
);
